module.exports = __webpack_public_path__ + "static/img/decor2.1eb11ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/statistics-charts/insurance-statistics/images/decor2.png
// module id = 18Cw
// module chunks = 202